import { useRouter } from 'next/router'

import { useBucket } from '@mc/experiments-react'
import { paths } from '@mc/paths'

import { PEN_5375_V1_TWO_PAGE_QR_FLAG } from './constants'

export const useTwoPageQRExperiment = () => {
  const bucket = useBucket(PEN_5375_V1_TWO_PAGE_QR_FLAG)
  const router = useRouter()
  const isQRPage = router.pathname.startsWith(paths.classRecommendationsResults)
  const isEnabled = !!bucket?.includes('variant') && isQRPage

  return {
    isEnabled,
    isVariant2: isEnabled && bucket === 'variant_2',
  }
}
